import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Box } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import TwoFactorLogin from '../../components/TwoFactorLogin/TwoFactorLogin';
import { getNextPath } from '../../AuthReducer';
import { saveNextPath } from '../../AuthActions';

const messages = defineMessages({
  title: {
    id: 'TwoFactorVerifyPage.Title',
    defaultMessage: 'Two-Factor Authentication - Promoter Ninja',
  },
});

function TwoFactorVerifyPage() {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const nextPath = useSelector(getNextPath);

  const userId = location.state?.userId;
  const redirectPath = location.state?.nextPath || nextPath;
  const hasPasskeys = location.state?.hasPasskeys;
  const provider = location.state?.provider;

  const handleComplete = useCallback(() => {
    // Clear any stored next path
    dispatch(saveNextPath(null));

    // Redirect to the intended destination or dashboard
    const destination = redirectPath || '/';
    navigate(destination, { replace: true });
  }, [navigate, redirectPath, dispatch]);

  const handleError = useCallback(error => {
    console.error('2FA verification error:', error);
    // Stay on the same page to allow retry
  }, []);

  // If no userId, redirect to login
  if (!userId) {
    navigate('/login', { replace: true });
    return null;
  }

  return (
    <Container maxWidth="sm">
      <Helmet title={formatMessage(messages.title)} />
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', py: 4 }}>
        <TwoFactorLogin
          userId={userId}
          hasPasskeys={hasPasskeys}
          provider={provider}
          onComplete={handleComplete}
          onError={handleError}
        />
      </Box>
    </Container>
  );
}

export default TwoFactorVerifyPage;
